import React from "react";

export default function AppMetaChip({ size = "md", className = "", children, ...props }) {
  const classes = ["ds-badge", `ds-badge--${size}`, className].filter(Boolean).join(" ");

  return (
    <span className={classes} {...props}>
      <span className="ds-badge__label">{children}</span>
    </span>
  );
}
